import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { AppBar, Box, Button, IconButton, Container, Toolbar, Typography, styled } from '@mui/material'
import { Search as SearchIcon, HelpOutline as FaqIcon } from '@mui/icons-material'
import { useWindowSize } from 'usehooks-ts'
import { Search } from '../../scenes'
import { resource } from '../../utils/utilities'
import DEFAULT from '../../config/default'

const Header = () => {
    const { width } = useWindowSize()
    const [isMobileSearchOpen, setIsMobileSearchOpen] = useState<boolean>(false)

    const handleOnClose = () => {
        setIsMobileSearchOpen(false)
    }

    return (
        <>
            <RootStyled position="fixed" sx={{ boxShadow: 1 }}>
                <Container>
                    <Toolbar disableGutters>
                        {DEFAULT.api.countryCode !== 'CH' && (
                            <LogoWrapperStyled>
                                <NavLink to="/">
                                    <img className="img-fluid" src={resource('images/logo.svg')} alt="Natura" style={{ height: 56 }} />
                                </NavLink>
                            </LogoWrapperStyled>
                        )}
                        <SearchWrapperStyled ownerState={{ isMobileSearchOpen }}>
                            <Search onClose={ width < 900 ? handleOnClose : undefined } reCaptchaEnabled={false} />
                        </SearchWrapperStyled>
                        <Box sx={{ flexGrow: 1 }} />
                        { DEFAULT.api.countryCode !== 'AR' && (
                            <NameWrapperStyled>
                                <Typography color="primary" variant="caption" lineHeight="1.2" textTransform="uppercase">Webtracking</Typography>
                                <Typography variant="caption" lineHeight="1.2" textTransform="uppercase">Seguimiento de pedidos</Typography>
                            </NameWrapperStyled>
                        )}
                        { DEFAULT.api.countryCode === 'AR' && (
                            <FaqButtonStyled component={NavLink} to="/faqs" color="primary" startIcon={<FaqIcon />}>
                                <FaqButtonTextStyled>Preguntas frecuentes</FaqButtonTextStyled>
                            </FaqButtonStyled>
                        )}
                        <SearchButtonOpenStyled>
                            <IconButton onClick={() => setIsMobileSearchOpen(true)}>
                                <SearchIcon />
                            </IconButton>
                        </SearchButtonOpenStyled>
                    </Toolbar>
                </Container>
            </RootStyled>
            <OffsetStyled />
        </>
    )
}

const RootStyled = styled(AppBar)(({ theme }) => ({
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    justifyContent: 'center',
    '@media all': {
        minHeight: 78
    }
}))

const OffsetStyled = styled('div')(({ theme }) => ({
    height: 78
}))


const LogoWrapperStyled = styled(Box)(({ theme }) => ({
    marginRight: 24
}))

const NameWrapperStyled = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    marginLeft: theme.spacing(3),
    textAlign: 'right'
}))

const SearchWrapperStyled = styled(Box)<{ownerState: { isMobileSearchOpen?: boolean }}>(({ theme, ownerState }) => ({
    [theme.breakpoints.up('md')]: {
        minWidth: 560
    },
    [theme.breakpoints.down('md')]: {
        display: 'none',
        position: 'absolute',
        background: theme.palette.common.white,
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        //display: 'flex',
        alignItems: 'center',
        zIndex: 9,
        ...((ownerState.isMobileSearchOpen) && {
            display: 'flex',
        })
    }
}))

const SearchButtonOpenStyled = styled(Box)(({ theme }) => ({
    marginLeft: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
        display: 'none'
    }
}))

const FaqButtonStyled = styled(Button)(({ theme }) => ({
    marginLeft: theme.spacing(1),
    flexShrink: 0,
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('md')]: {
        minWidth: 'auto',
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
        '& .MuiButton-startIcon': {
            margin: 0
        }
    }
}))

const FaqButtonTextStyled = styled('span')(({ theme }) => ({
    [theme.breakpoints.down('md')]: {
        display: 'none'
    }
}))


export default Header
